export const typeSafeObjectKeys = <T>(obj: T) => {
  return Object.keys(obj) as (keyof T)[];
};
